import React, {useEffect, useState} from 'react';
import OrbitMaker from './OrbitMakerV2/OrbitMaker'
import Splash from "./Splash/Splash";
import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import MainMenu from "./MainMenu/MainMenu";
import ExploreOrbit from "./ExploreOrbit/ExploreOrbit";
import QuizV2 from "./QuizV2/QuizV2";
import Scenario from "./Scenario/Scenario";
import CollapsibleActionBar from "./CollapsibleActionBar/CollapsibleActionBar";
import AskTheTeam from "./AskTheTeam/AskTheTeam";
import styles from './Orbits.modules.scss';
import axios from "axios";
import { OrbitsProvider} from "./Context/OrbitsContext";
import StoryLessonV2 from "./StoryLessonV2/StoryLessonV2";
import Button, {ButtonsHolder} from "../../partials/Button";
import TeamMember from "./TeamMember/TeamMember";
import {SimpleModal} from "../../partials/Modal";
import LoadingIndicator from "../../partials/LoadingIndicator/LoadingIndicator";

const SEGMENTS_STATES = {
	SPLASH: "splash",
	CONCEPTUAL_MAIN: "conceptualmain",
	EXPLORE_ORBITS: "exploreorbit",
	QUIZ: "quiz",
	SCENARIO: "scenario",
	MAKER: "maker",
	STORY_MAIN: "storymain",
}
const OrbitsWrapper = (props) => {
    const isStory =  props.data?.subtype === 'story'
    const [isLoading, setIsLoading] = React.useState(true)
    const [currentGoBackCallback, setCurrentGoBackCallback] = useState(() =>  () => props.goBackToPreviousSegment)
    const [initialView, setInitialView] = React.useState(SEGMENTS_STATES.CONCEPTUAL_MAIN)// React.useState(props.data.subtype === 'story' ? 'storymain' : 'conceptualmain')
    const team  = props?.data?.stories &&  props.data.stories.length > 0 && props.data.stories[0]?.team || []
    const [segmentState, setSegmentState] = React.useState(initialView)
    const [scenariosUnlocked, setScenariosUnlocked] = React.useState(false)
    const [hasCompletedScenarios, setHasCompletedScenarios] = React.useState(false);
    const [currentClickedMember, setCurrentClickedMember] = React.useState(false)

    const [orbitsCheck, setOrbitsCheck] = React.useState(() => {
       return  props.data.orbits.map(o => ({
           ...o,
           checked: false,
        }))
    })
    const [currentBackground, setCurrentBackground] = React.useState('starfield')
    const [currentSelectedOrbit, setCurrentSelectedOrbit]  = React.useState(props.data.orbits[0])

    const [groundData, setGroundData] = React.useState({
        leo: [],
        meo: [],
        heo: [],
        geo: []
    });

    const [storyData, setStoryData] = React.useState()
    React.useEffect( () => {
        // Fetch GroundData
        async function fetchOrbitData() {
        try {
            const leo = (await axios.get('json/leo.json')).data
            const meo = (await axios.get('json/meo.json')).data
            const heo = (await axios.get('json/heo.json')).data
            const geo = (await axios.get('json/geo.json')).data
            setGroundData({
                leo,
                meo,
                heo,
                geo,
            })
            if (isStory && props?.data.storyData) {
            // Load story specific ground data.
               const storyData = (await axios.get(`json/${props?.data.storyData}.json`)).data
               setStoryData(storyData)
            } else {
                setStoryData(false)
            }

     } catch(e) {
            setIsLoading(false)
            throw new Error("While fetching orbit csv data : "+e.message || 'Unknown error')
     }}
     fetchOrbitData().finally(() => setIsLoading(false))
    }, [])


    const handleStartClick = () => {
        setSegmentState('conceptualmain')
    }


    useEffect( () => {
        setScenariosUnlocked(orbitsCheck.every(o => o.checked))
    },[orbitsCheck])

    // Handlers
    const handleOrbitStart = (orbit) => {
        setCurrentSelectedOrbit(orbit)
        setSegmentState('exploreorbit')
    }

    const handleTeamMemberClick = (t) => {
        setCurrentClickedMember(t)
    }


    // Loading Do nothing
    const loader = (isLoading) ? <LoadingIndicator caption={'Loading Orbits Data ...'} /> : null;

    const modal = (
        <SimpleModal
        className={styles.TeamFeedbackModal}
        size={'small'}
        show={currentClickedMember !== false}
        showContinue={true}>
        <TeamMember member={currentClickedMember} />
        <ButtonsHolder orientation={'center'}>
            <Button text={'CLOSE'} onClick={() => setCurrentClickedMember(false)}></Button>
        </ButtonsHolder>
    </SimpleModal>
    )

    const storyJSX = (
        <div className={styles.CollapsiblesContainer}>
            <StoryLessonV2
                orbits={props.data?.orbits} stories={props.data?.stories}
                onBack={() => props.goBackToPreviousSegment()}
                onContinue={() => props.onComplete()}
                onOrbitSelected={o => setCurrentSelectedOrbit(o)}
            >
            </StoryLessonV2>

            <CollapsibleActionBar title={'Ask The Team'}>
                <AskTheTeam team={team} onClick={handleTeamMemberClick} />
            </CollapsibleActionBar>
        </div>
    )

    const GetCurrentSegment = () => {
        switch (segmentState) {
            case `splash`:
                return <Splash
                    mainMessage={props?.data?.splash?.mainMessage}
                    headerCaption={props?.data?.splash?.headerCaption}
                    subHeaderCaption={props?.data?.splash?.subHeaderCaption}
                    callToActionCaption={props?.data?.splash?.callToActionCaption}
                    onStartClick={handleStartClick}
                />
            case `conceptualmain`:
                if (isStory)
                    return (
                        <div className="back-btn-container" style={{ zIndex: 10 }} >
                            <Button variant={'back'} text={'BACK'} onClick={() => {
                                props.goBackToPreviousSegment()
                            }} />
                        </div>
                    );
                else
                    return <MainMenu
                        onComplete={() => props.onComplete()}
                        orbits={orbitsCheck || []}
                        story={props.data.stories}
                        setBackground={setCurrentBackground}
                        unlocked={scenariosUnlocked}
                        onStartOrbit={handleOrbitStart}
                        onSelectedScenario={() => setSegmentState('scenario')}
                        enableCompleteButton={hasCompletedScenarios === true || props?.doScenarions !== true}
                        completeButtonCaption={props?.data?.completeButtonCaption}
                        continueButtonCaption={props?.data?.continueButtonCaption}
                        instructions={props?.data?.instructions || ''}
                    />;

            case `exploreorbit`:
                if (currentSelectedOrbit)
                    return <ExploreOrbit
                        orbit={currentSelectedOrbit}
                        dispatchers={{
                            goBackToPreviousSegment: props?.goBackToPreviousSegment,
                            setCurrentBackground
                        }}
                        onContinue={() => {
                            setSegmentState('quiz')
                        }}
                        onGoBack={() => setSegmentState('conceptualmain')}
                    />
                else
                    throw new Error(`Current Segment is Explore orbit but no current Orbit is selected`)

            case `quiz`:
                return <QuizV2
                    orbit={currentSelectedOrbit}
                    story={props?.stories}
                    dispatchers={{
                        goBackToPreviousSegment: props?.goBackToPreviousSegment,
                        setCurrentBackground
                    }}
                    onGoBack={() => {
                        setSegmentState('exploreorbit')
                    }}
                    onContinue={(isCorrect, orbit) => {
                        setOrbitsCheck(orbitsCheck.map(o => {
                            if (o.header === orbit.header) {
                                return { ...o, checked: true }
                            }
                            return o
                        }))
                        setSegmentState('conceptualmain')
                    }}
                />;

            case `scenario`:
                return <Scenario
                    orbits={orbitsCheck || []}
                    story={props.data.stories[1]}
                    setBackground={setCurrentBackground}
                    unlocked={scenariosUnlocked}
                    onContinue={() => {
                        setHasCompletedScenarios(true)
                        setOrbitsCheck(orbitsCheck.map(o => ({ ...o, checked: true })))
                        setScenariosUnlocked(true)
                        setSegmentState('conceptualmain')
                    }}
                    onBack={() => { setSegmentState('conceptualmain') }}
                    onStartOrbit={handleOrbitStart}
                />;

            case `maker`:
                return <OrbitMaker orbits={orbitsCheck} />;

            case `storymain`:
                return (team) ? <>Story Main</> : null

            default:
                throw new Error(`This is not a story isStory:${isStory} and the current segment ${segmentState} cound not be handle`)

        }
    }

    return (
        <OrbitsProvider value={{
            config: {
                ...props?.data
            },
            currentSelectedOrbit,
            setCurrentSelectedOrbit,
            groundData,
            isSingleSlider: props.data?.isSingleSlider === true,
            singleSliderValues: props.data?.singleSliderValues || [],
            storyData,
            setCurrentGoBackCallback,
            options: {
                groundTracksDoDots: props.data?.groundTracksDoDots === true,
                groundTrackDotsColor: props.data?.groundTrackDotsColor || 'red',
                groundTrackSmoothLines: props.data?.groundTrackSmoothLines === true,
                PlotSampleCities: props.data?.PlotSampleCities === true
            }
        }} >
            {loader}
            {modal}
            <InteractionContainer breadcrumbs={props?.breadcrumbs} variant={currentBackground} withFrame={segmentState === 'exploreorbit'}>
                {GetCurrentSegment()}
                {isStory === true && storyJSX}
            </InteractionContainer>

        </OrbitsProvider>
    )
}

export default OrbitsWrapper;
